import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./author.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";

const addAuthorEndpoint = ApiEndpoints.autor.authorCreate;

export default function AddAuthor() {
  const navigate = useNavigate();
  const [previewImage, setPreviewImage] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    designation: "",
    description: "",
    image: null, // For file uploads
    facebook: "",
    linkedin: "",
    instagram: "",
  });

  const handleChange = useCallback((event) => {
    const { name, value, type, files } = event.target;

    if (name === "image" && type === "file") {
      const file = files[0];
      if (file) {
        const objectUrl = URL.createObjectURL(file);
        setPreviewImage(objectUrl);
      }
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "file" ? files[0] : value,
    }));
  }, []);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();

      // Create a new FormData instance
      const payload = new FormData();

      // Add all form fields except the image
      Object.keys(formData).forEach((key) => {
        if (key !== "image") {
          payload.append(key, formData[key]);
        }
      });

      // Append the image field if it exists
      if (formData.image) {
        payload.append("image", formData.image);
      }

      try {
        // Send the API request with the FormData payload
        const response = await ApiRequest("POST", addAuthorEndpoint, payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (response.error === true) {
          toast.error(response.message)
        } else {
          toast.success(response.message)
          navigate("/admin/author");
        }
      } catch (error) {
        console.error("Error updating author:", error);
      }
    },
    [formData, navigate]
  );

  return (
    <>
      <div className="header-add-category">
        <h5>Add Author</h5>
      </div>
      <div className="add-author-content">
        <form onSubmit={handleSubmit}>
          <label>Name*:</label>
          <input type="text" name="name" value={formData.name} onChange={handleChange} required className="form-control" />

          <label>Designation*:</label>
          <input type="text" name="designation" value={formData.designation} onChange={handleChange} className="form-control" required />

          <label>Description*:</label>
          <textarea name="description" value={formData.description} onChange={handleChange} className="form-control" required />

          <label>Image (112X112 px)*:</label>
          <input type="file" name="image" onChange={handleChange} className="form-control" required />
          {previewImage && (
            <div style={{ width: "60px", height: "60px", margin: "10px 0", overflow: "hidden" }}>
              <img src={previewImage} alt="Preview" className="img-responsive" />
            </div>
          )}

          <label>Facebook:</label>
          <input type="url" name="facebook" value={formData.facebook} onChange={handleChange} className="form-control" />

          <label>LinkedIn:</label>
          <input type="url" name="linkedin" value={formData.linkedin} onChange={handleChange} className="form-control" />

          <label>Instagram:</label>
          <input type="url" name="instagram" value={formData.instagram} onChange={handleChange} className="form-control" />

          <div className="submit-formbtn mt-4">
            <button type="submit" className="default-btn">
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
